/* tool-see-on-wall.js — "See It on Your Wall" visualizer.
   2D canvas only: no WebGL, no libraries, no external requests beyond the
   catalogue shards and the Shopify CDN images. Every bit of user state lives
   in location.hash, so 35,000 paintings share exactly one crawlable URL.

   SCALE MODEL
   -----------
   Every scene photo is 1024x1024 and carries a calibration `ppi` = pixels per
   inch measured AT THE WALL PLANE, derived from one object of known real size
   inside that photo (see SCENES[].ref for the object and the pixel span used).
   A painting of W inches is therefore drawn W * ppi * k pixels wide, where
   k = canvasCssWidth / 1024. Uploaded photos get the same treatment: the user
   drags a two-point line over a reference of known length (sofa 84 in, door
   80 in, or their own wall width) and ppi = lineLengthPx / referenceInches.
   Nothing else in this file guesses at size. */
(function () {
  'use strict';
  var TOOL = 'see-art-on-your-wall';
  var root = document.querySelector('[data-sow]');
  if (!root) return;
  var CFG = window.SOW || {};
  var SRC = 1024; /* scene photos are 1024x1024 */

  /* ---------------------------------------------------------------- scenes
     The eleven photographs, their measured `ppi`, wall rectangle, floor line and
     anchor now live in assets/tools-room-render.js, because the wall art size
     calculator draws its recommendation in the same rooms and one calibration
     measured twice is one calibration wrong twice. Same table, same numbers,
     one owner. `pdpSlug`/`pdpLabel` there are the labels this same photo carries
     in the PDP room visualiser (main-product-drehmer.liquid:202-207). */
  var ROOM = window.ArtSeeRoom;
  if (!ROOM) { var hb = root.querySelector('[data-sow-hint]'); if (hb) { hb.style.display = ''; hb.textContent = 'The room engine did not load. Reload the page.'; } return; }
  var SCENES = ROOM.scenes;
  var BUCKET = {
    small: ['master-bedroom', 'entryway', 'living-room', 'sofa-wall'],
    mid: ['sofa-wall', 'living-room', 'study', 'luxe-bedroom', 'fireplace', 'minimal-bedroom', 'entryway'],
    big: ['gallery-room', 'dining-room', 'stair-hall', 'minimal-bedroom', 'study']
  };
  /* the seven real sizes per orientation set (CONTRATO meta.sizeSets) */
  var SETS = {
    0: [[16, 20], [20, 24], [24, 30], [30, 40], [36, 48], [40, 60], [48, 72]],
    1: [[20, 16], [24, 20], [30, 24], [40, 30], [48, 36], [60, 40], [72, 48]],
    2: [[16, 16], [20, 20], [24, 24], [30, 30], [36, 36], [48, 48], [60, 60]]
  };
  var REFS = [
    { id: 'sofa', label: 'My sofa is 84 in wide', inches: 84, axis: 'x' },
    { id: 'door', label: 'A standard door is 80 in tall', inches: 80, axis: 'y' },
    { id: 'wall', label: 'I know my wall width', inches: 0, axis: 'x' }
  ];
  var R = { H: 0, T: 1, A: 2, RAT: 3, P: 4, E: 8, Z: 9, IMG: 10 };
  var FRAMES = ['none', 'black', 'walnut', 'gold'];

  /* ------------------------------------------------------ catalogue facade */
  function api() { var c = window.ArtSeeCatalog; return (c && typeof c.search === 'function') ? c : null; }
  function imgUrl(row, w) {
    var c = api(); if (c && c.imageUrl) return c.imageUrl(row, w || 400);
    return (CFG.imgBase || 'https://art-and-see.com/cdn/shop/files/') + row[R.IMG] + '&width=' + (w || 400);
  }
  function pdpUrl(row, size) {
    var c = api(); if (c && c.pdpUrl) return c.pdpUrl(row, size ? { size: size } : {});
    return '/products/' + row[R.H] + (size ? '#size=' + size : '');
  }
  function sizesOf(set) {
    var c = api();
    if (c && c.sizes) { try { var s = c.sizes(set); if (s && s.length) return s.map(function (o) { return [o.w, o.h]; }); } catch (e) { } }
    return SETS[set] || SETS[1];
  }
  function track(ev, params) {
    var c = api(); var p = params || {}; p.tool = TOOL;
    if (c && c.track) { try { c.track(ev, p); return; } catch (e) { } }
    window.dataLayer = window.dataLayer || []; p.event = ev; window.dataLayer.push(p);
  }
  function load(which) {
    var c = api(); if (!c || !c.load) return Promise.resolve([]);
    try { return Promise.resolve(c.load(which)).catch(function () { return []; }); } catch (e) { return Promise.resolve([]); }
  }
  function search(q, opt) {
    var c = api(); if (!c) return Promise.resolve([]);
    try { return Promise.resolve(c.search(q, opt || { limit: 16 })).catch(function () { return []; }); } catch (e) { return Promise.resolve([]); }
  }

  /* --------------------------------------------------------------- helpers */
  var $ = function (s, n) { return (n || root).querySelector(s); };
  var $$ = function (s, n) { return Array.prototype.slice.call((n || root).querySelectorAll(s)); };
  function el(tag, cls, txt) { var e = document.createElement(tag); if (cls) e.className = cls; if (txt != null) e.textContent = txt; return e; }
  function num(v, d) { var n = parseFloat(v); return isFinite(n) ? n : d; }
  function clamp(v, a, b) { return v < a ? a : v > b ? b : v; }
  function setOf(w, h) { return w === h ? 2 : w > h ? 1 : 0; }
  function money(v) { return '$' + (Math.round(v * 100) / 100).toFixed(2).replace(/\.00$/, ''); }
  function inch(v) { return Math.round(v) + ' in'; }
  function cm(v) { return Math.round(v * 2.54) + ' cm'; }
  function unitTxt(v) { return S.unit === 'cm' ? cm(v) : inch(v); }
  function loadImage(src, anon) {
    return new Promise(function (res, rej) {
      var i = new Image();
      if (anon !== false) i.crossOrigin = 'anonymous';
      i.onload = function () { res(i); }; i.onerror = function () { rej(new Error('img ' + src)); };
      i.src = src;
    });
  }
  var sceneById = ROOM.sceneById;
  var sceneUrl = ROOM.sceneUrl;

  /* ----------------------------------------------------------------- state */
  var S = {
    mode: 'scene', scene: 'sofa-wall', sceneLocked: false, frame: 'none',
    unit: 'in', dims: false, compare: false, preset: 'sofa', refInches: 84,
    items: [], photo: null, open: false
  };
  function blankItem() { return { row: null, handle: '', local: null, img: null, w: 24, h: 36, x: 50, y: 45, placed: false }; }

  /* ------------------------------------------------------------ hash state */
  function readHash() {
    var h = location.hash.replace(/^#/, ''); var o = {};
    h.split('&').forEach(function (p) {
      if (!p) return; var i = p.indexOf('='); if (i < 0) return;
      o[decodeURIComponent(p.slice(0, i))] = decodeURIComponent(p.slice(i + 1));
    });
    return o;
  }
  var hashTimer = null;
  function writeHash() {
    if (hashTimer) clearTimeout(hashTimer);
    hashTimer = setTimeout(function () {
      var p = [], it = S.items[0];
      if (it && it.handle) p.push('art=' + it.handle);
      if (it) p.push('size=' + it.w + 'x' + it.h);
      p.push('scene=' + S.scene);
      p.push('frame=' + S.frame);
      if (S.mode === 'photo' && S.photo && S.photo.ppi) p.push('wall=' + Math.round(S.photo.wIn) + 'x' + Math.round(S.photo.hIn) + 'in');
      if (it) { p.push('x=' + it.x.toFixed(1)); p.push('y=' + it.y.toFixed(1)); }
      for (var i = 1; i < S.items.length; i++) {
        var j = S.items[i], n = i + 1;
        if (j.handle) p.push('art' + n + '=' + j.handle);
        p.push('size' + n + '=' + j.w + 'x' + j.h);
        p.push('x' + n + '=' + j.x.toFixed(1)); p.push('y' + n + '=' + j.y.toFixed(1));
      }
      if (S.unit !== 'in') p.push('u=cm');
      if (S.dims) p.push('d=1');
      if (S.compare) p.push('c=1');
      try { history.replaceState(null, '', location.pathname + location.search + '#' + p.join('&')); } catch (e) { }
    }, 120);
  }
  function parseSize(v) {
    var m = String(v || '').match(/(\d+(?:\.\d+)?)\s*[xX×]\s*(\d+(?:\.\d+)?)/);
    return m ? { w: +m[1], h: +m[2] } : null;
  }

  /* ----------------------------------------------------------------- scene */
  function bucketFor(w) { return w <= 20 ? 'small' : w >= 48 ? 'big' : 'mid'; }
  function autoScene(w, h) {
    var list = BUCKET[bucketFor(w)], i, s;
    for (i = 0; i < list.length; i++) {
      s = sceneById(list[i]);
      if (s && s.wall.w / s.ppi >= w + 10 && s.wall.h / s.ppi >= h + 10) return s.id;
    }
    for (i = 0; i < SCENES.length; i++) {
      s = SCENES[i];
      if (s.wall.w / s.ppi >= w + 10 && s.wall.h / s.ppi >= h + 10) return s.id;
    }
    return 'gallery-room';
  }
  function plane() {
    /* current background plane: {img, ppi(src px per inch), wall, floor, anchor} */
    if (S.mode === 'photo' && S.photo && S.photo.img) {
      return { img: S.photo.img, ppi: S.photo.ppi || 0, wall: S.photo.wall, floor: S.photo.floor, anchor: { mode: 'floor' }, w: S.photo.img.naturalWidth, h: S.photo.img.naturalHeight };
    }
    var sc = sceneById(S.scene) || SCENES[0];
    return { img: sceneImg, ppi: sc.ppi, wall: sc.wall, floor: sc.floor, anchor: sc.anchor, w: SRC, h: SRC, scene: sc };
  }
  /* keep a piece of wIn inches inside the usable wall rectangle */
  function clampX(xPct, wIn) {
    var p = plane(); if (!p.ppi) return clamp(xPct, 4, 96);
    var half = wIn * p.ppi / p.w * 100 / 2;
    var lo = (p.wall ? p.wall.x : 0) / p.w * 100 + half;
    var hi = (p.wall ? p.wall.x + p.wall.w : p.w) / p.w * 100 - half;
    if (lo > hi) return 50;
    return clamp(xPct, lo, hi);
  }
  function defaultPos(item) {
    var p = plane(); if (!p.ppi) { item.x = 50; item.y = 45; return; }
    var sc = p.scene;
    item.x = sc ? sc.cx : 50;
    var cy;
    if (sc && sc.anchor.mode === 'shelf') cy = sc.anchor.y - (sc.anchor.gap * p.ppi) - (item.h * p.ppi) / 2;
    else if (p.floor != null) cy = p.floor - 57 * p.ppi;
    else cy = p.h * 0.42;
    item.y = clamp((cy / p.h) * 100, 6, 94);
  }

  /* ---------------------------------------------------------------- canvas */
  var canvas = $('[data-sow-canvas]'), ctx = canvas.getContext('2d');
  var preview = $('[data-sow-preview]');
  var sceneImg = null, sceneLoading = '';
  var view = { w: 0, h: 0, k: 1 };

  function ensureScene() {
    var sc = sceneById(S.scene) || SCENES[0];
    if (sceneLoading === sc.id && sceneImg) return Promise.resolve(sceneImg);
    sceneLoading = sc.id;
    return loadImage(sceneUrl(sc.n, false)).then(function (i) {
      if (sceneLoading === sc.id) sceneImg = i;
      return i;
    }).catch(function () { return null; });
  }

  function frameWidthIn(item) { return ROOM.frameWidthIn(item.w, S.frame); }

  /* shadow, frame, bevel and gallery-wrap depth are ROOM.drawArt now; the numbers
     below are the same ones this file used before the extraction */
  function drawItem(c, item, k, ppi) {
    if (!item.img) return null;
    return ROOM.drawArt(c, {
      img: item.img,
      cx: item.x / 100 * view.w, cy: item.y / 100 * view.h,
      wPx: item.w * ppi * k, hPx: item.h * ppi * k,
      frame: S.frame, framePx: frameWidthIn(item) * ppi * k,
      depth: clamp(2 * k * (view.w / 900), 2, 4),
      blur: clamp(view.w / 62, 12, 18),
      sx: clamp(view.w / 260, 3, 6),
      sy: clamp(view.w / 130, 6, 12)
    });
  }

  function label(c, txt, x, y) {
    c.font = '600 ' + clamp(view.w / 68, 10, 15).toFixed(0) + 'px -apple-system,Segoe UI,Roboto,sans-serif';
    var pad = 5, m = c.measureText(txt).width;
    c.fillStyle = 'rgba(17,17,17,.82)';
    c.fillRect(x - m / 2 - pad, y - 13, m + pad * 2, 19);
    c.fillStyle = '#fff'; c.textAlign = 'center'; c.textBaseline = 'middle';
    c.fillText(txt, x, y - 3.5);
  }

  function drawDims(c, box, k, ppi, p) {
    var y = box.y + box.h / 2;
    c.save();
    c.strokeStyle = 'rgba(17,17,17,.55)'; c.lineWidth = 1; c.setLineDash([5, 4]);
    var wall = p.wall;
    if (wall) {
      var wx0 = wall.x * k, wx1 = (wall.x + wall.w) * k;
      c.beginPath(); c.moveTo(wx0, y); c.lineTo(box.x, y); c.moveTo(box.x + box.w, y); c.lineTo(wx1, y); c.stroke();
      c.beginPath(); c.moveTo(wx0, y - 9); c.lineTo(wx0, y + 9); c.moveTo(wx1, y - 9); c.lineTo(wx1, y + 9); c.stroke();
      c.setLineDash([]);
      label(c, unitTxt((box.x - wx0) / k / ppi), (wx0 + box.x) / 2, y);
      label(c, unitTxt((wx1 - box.x - box.w) / k / ppi), (box.x + box.w + wx1) / 2, y);
    }
    c.setLineDash([]);
    label(c, S.unit === 'cm' ? cm(box.iw / k / ppi) + ' x ' + cm(box.ih / k / ppi) : Math.round(box.iw / k / ppi) + ' x ' + Math.round(box.ih / k / ppi) + ' in', box.x + box.w / 2, box.y - 6);
    if (p.floor != null) {
      var fy = p.floor * k;
      c.strokeStyle = 'rgba(17,17,17,.45)'; c.setLineDash([5, 4]);
      c.beginPath(); c.moveTo(box.x + box.w / 2, y); c.lineTo(box.x + box.w / 2, fy); c.stroke(); c.setLineDash([]);
      label(c, unitTxt((fy - y) / k / ppi) + ' to floor', box.x + box.w / 2, (y + fy) / 2);
    }
    c.restore();
  }

  function paint(c, k, ppi, p) {
    if (p.img) { try { c.drawImage(p.img, 0, 0, view.w, view.h); } catch (e) { } }
    else { c.fillStyle = '#EFEAE3'; c.fillRect(0, 0, view.w, view.h); }
    if (!ppi) return [];
    var boxes = [], i;
    if (S.compare && S.items[0] && S.items[0].img) {
      var base = S.items[0], set = setOf(base.w, base.h), all = sizesOf(set);
      var trio = [all[1], all[3], all[5]], gap = 6 * ppi * k, total = 0;
      for (i = 0; i < 3; i++) total += trio[i][0] * ppi * k;
      total += gap * 2;
      var cursor = (view.w - total) / 2, names = ['Small', 'Medium', 'Large'];
      for (i = 0; i < 3; i++) {
        var tmp = { img: base.img, w: trio[i][0], h: trio[i][1], x: 0, y: base.y };
        tmp.x = ((cursor + trio[i][0] * ppi * k / 2) / view.w) * 100;
        var b = drawItem(c, tmp, k, ppi);
        if (b) { boxes.push(b); label(c, names[i] + ' ' + trio[i][0] + ' x ' + trio[i][1] + ' in', b.x + b.w / 2, b.y + b.h + 20); }
        cursor += trio[i][0] * ppi * k + gap;
      }
      return boxes;
    }
    for (i = 0; i < S.items.length; i++) {
      var box = drawItem(c, S.items[i], k, ppi);
      boxes.push(box);
      if (box && S.dims) drawDims(c, box, k, ppi, p);
    }
    return boxes;
  }

  var lastBoxes = [];
  function render() {
    var p = plane();
    var w = canvas.parentNode.clientWidth || 720;
    var ar = p.h / p.w;
    view.w = w; view.h = Math.round(w * ar); view.k = w / p.w;
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    canvas.width = Math.round(view.w * dpr); canvas.height = Math.round(view.h * dpr);
    canvas.style.width = view.w + 'px'; canvas.style.height = view.h + 'px';
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    lastBoxes = paint(ctx, view.k, p.ppi, p);
    if (calib.active) drawCalib();
    if (preview) {
      preview.width = 640; preview.height = Math.round(640 * ar);
      var pc = preview.getContext('2d');
      pc.drawImage(canvas, 0, 0, preview.width, preview.height);
    }
  }

  /* export at source resolution so the download is not a screenshot of a box */
  function exportJpeg() {
    var p = plane();
    var c2 = document.createElement('canvas');
    c2.width = p.w; c2.height = p.h;
    var c = c2.getContext('2d');
    var keep = { w: view.w, h: view.h, k: view.k };
    view.w = p.w; view.h = p.h; view.k = 1;
    paint(c, 1, p.ppi, p);
    view.w = keep.w; view.h = keep.h; view.k = keep.k;
    c.font = '600 ' + Math.round(p.w / 48) + 'px -apple-system,Segoe UI,Roboto,sans-serif';
    c.textAlign = 'right'; c.textBaseline = 'alphabetic';
    c.fillStyle = 'rgba(0,0,0,.34)'; c.fillText('art-and-see.com', p.w - 17, p.h - 16);
    c.fillStyle = 'rgba(255,255,255,.92)'; c.fillText('art-and-see.com', p.w - 18, p.h - 18);
    return c2.toDataURL('image/jpeg', 0.9);
  }

  /* ------------------------------------------------------------- dragging */
  var drag = null;
  function pos(e) {
    var r = canvas.getBoundingClientRect();
    return { x: (e.clientX - r.left), y: (e.clientY - r.top) };
  }
  canvas.addEventListener('pointerdown', function (e) {
    var q = pos(e);
    if (calib.active) { calib.a = q; calib.b = q; calib.dragging = true; canvas.setPointerCapture(e.pointerId); render(); return; }
    if (S.compare) return;
    for (var i = lastBoxes.length - 1; i >= 0; i--) {
      var b = lastBoxes[i];
      if (b && q.x >= b.x && q.x <= b.x + b.w && q.y >= b.y && q.y <= b.y + b.h) {
        drag = { i: i, dx: q.x - (S.items[i].x / 100 * view.w), dy: q.y - (S.items[i].y / 100 * view.h) };
        canvas.classList.add('is-drag'); canvas.setPointerCapture(e.pointerId); return;
      }
    }
  });
  canvas.addEventListener('pointermove', function (e) {
    var q = pos(e);
    if (calib.dragging) { calib.b = q; render(); return; }
    if (!drag) return;
    var it = S.items[drag.i], p = plane();
    var cx = q.x - drag.dx, cy = q.y - drag.dy;
    /* snap the centre to 57 in above the floor when the floor line is known */
    if (p.floor != null && p.ppi) {
      var snap = (p.floor - 57 * p.ppi) * view.k;
      if (Math.abs(cy - snap) < 8) cy = snap;
    }
    it.x = clamp(cx / view.w * 100, 2, 98);
    it.y = clamp(cy / view.h * 100, 2, 98);
    render();
  });
  function endDrag(e) {
    if (calib.dragging) { calib.dragging = false; finishCalib(); return; }
    if (!drag) return; drag = null; canvas.classList.remove('is-drag'); writeHash();
  }
  canvas.addEventListener('pointerup', endDrag);
  canvas.addEventListener('pointercancel', endDrag);

  /* --------------------------------------------------------- photo mode */
  var calib = { active: false, a: null, b: null, dragging: false, floorMode: false };
  function drawCalib() {
    if (!calib.a || !calib.b) return;
    var c = ctx;
    c.save(); c.strokeStyle = '#417505'; c.lineWidth = 3;
    c.beginPath(); c.moveTo(calib.a.x, calib.a.y); c.lineTo(calib.b.x, calib.b.y); c.stroke();
    c.fillStyle = '#417505';
    [calib.a, calib.b].forEach(function (p) { c.beginPath(); c.arc(p.x, p.y, 6, 0, 7); c.fill(); });
    c.restore();
  }
  function finishCalib() {
    if (!calib.a || !calib.b || !S.photo) return;
    var dx = (calib.b.x - calib.a.x) / view.k, dy = (calib.b.y - calib.a.y) / view.k;
    var len = Math.sqrt(dx * dx + dy * dy);
    if (len < 12) return;
    var inches = S.preset === 'wall' ? num($('[data-sow-refin]').value, 0) : S.refInches;
    if (!inches) { setHint('Enter your wall width in inches first.'); return; }
    S.photo.ppi = len / inches;
    S.photo.wIn = S.photo.img.naturalWidth / S.photo.ppi;
    S.photo.hIn = S.photo.img.naturalHeight / S.photo.ppi;
    if (S.preset === 'wall') S.photo.wall = { x: Math.min(calib.a.x, calib.b.x) / view.k, y: 0, w: Math.abs(dx), h: S.photo.img.naturalHeight };
    calib.active = false; calib.a = calib.b = null;
    S.items.forEach(defaultPos);
    setHint('Scale set: ' + S.photo.ppi.toFixed(1) + ' px per inch. Drag the painting to place it.');
    saveWall(); syncUI(); render(); writeHash();
    track('tool_result', { mode: 'photo', ppi: +S.photo.ppi.toFixed(2) });
  }
  function setHint(t) { var h = $('[data-sow-hint]'); if (h) { h.textContent = t || ''; h.style.display = t ? '' : 'none'; } }

  function usePhoto(file) {
    var fr = new FileReader();
    fr.onload = function () {
      loadImage(fr.result, false).then(function (img) {
        var max = 1600, w = img.naturalWidth, h = img.naturalHeight, sc = Math.min(1, max / Math.max(w, h));
        var c = document.createElement('canvas'); c.width = Math.round(w * sc); c.height = Math.round(h * sc);
        c.getContext('2d').drawImage(img, 0, 0, c.width, c.height);
        return loadImage(c.toDataURL('image/jpeg', 0.86), false);
      }).then(function (small) {
        S.mode = 'photo';
        S.photo = { img: small, ppi: 0, floor: null, wall: null, wIn: 0, hIn: 0 };
        calib.active = true; calib.a = calib.b = null;
        setHint('Drag a line across your reference (' + (S.preset === 'wall' ? 'your wall width' : REFS.filter(function (r) { return r.id === S.preset; })[0].label.toLowerCase()) + ').');
        syncUI(); render();
        track('tool_open', { mode: 'photo' });
      }).catch(function () { setHint('That image could not be read. Try a JPEG or PNG.'); });
    };
    fr.readAsDataURL(file);
  }

  /* ------------------------------------------------ saved walls (local) */
  var LS = 'asee_sow_walls';
  function readWalls() { try { return JSON.parse(localStorage.getItem(LS) || '[]'); } catch (e) { return []; } }
  function saveWall() {
    if (!S.photo || !S.photo.ppi) return;
    try {
      var c = document.createElement('canvas'), ar = S.photo.img.naturalHeight / S.photo.img.naturalWidth;
      c.width = 240; c.height = Math.round(240 * ar);
      c.getContext('2d').drawImage(S.photo.img, 0, 0, c.width, c.height);
      var thumb = c.toDataURL('image/jpeg', 0.6);
      if (thumb.length > 100000) thumb = c.toDataURL('image/jpeg', 0.4);
      var list = readWalls();
      list.unshift({ t: Date.now(), ppi: S.photo.ppi, floor: S.photo.floor, wIn: S.photo.wIn, thumb: thumb });
      localStorage.setItem(LS, JSON.stringify(list.slice(0, 5)));
      renderWalls();
    } catch (e) { }
  }
  function renderWalls() {
    var box = $('[data-sow-walls]'); if (!box) return;
    var list = readWalls(); box.innerHTML = '';
    $('[data-sow-walls-block]').style.display = list.length ? '' : 'none';
    list.forEach(function (w, i) {
      var b = el('button'); b.type = 'button'; b.title = 'Wall ' + Math.round(w.wIn) + ' in wide';
      var im = el('img'); im.src = w.thumb; im.alt = 'Saved wall ' + (i + 1); b.appendChild(im);
      b.onclick = function () {
        loadImage(w.thumb, false).then(function (img) {
          S.mode = 'photo';
          S.photo = { img: img, ppi: img.naturalWidth / w.wIn, floor: w.floor, wall: null, wIn: w.wIn, hIn: img.naturalHeight / (img.naturalWidth / w.wIn) };
          S.items.forEach(defaultPos); calib.active = false; setHint(''); syncUI(); render(); writeHash();
        });
      };
      box.appendChild(b);
    });
  }

  /* ------------------------------------------------------------- artwork */
  function applyRow(item, row) {
    item.row = row; item.handle = row[R.H]; item.local = null;
    var z = row[R.Z], rat = +row[R.RAT] || 1;
    item.set = (z != null && z >= 0) ? +z : (rat > 1.05 ? 1 : rat < 0.95 ? 0 : 2);
    return loadImage(imgUrl(row, 700)).then(function (i) { item.img = i; }).catch(function () { item.img = null; });
  }
  /* a painting is only sold in the seven sizes of its own orientation set, so a
     hash that asks for a size outside that set snaps to the nearest one we sell */
  function snapSize(set, w, h) {
    var list = sizesOf(set), best = list[0], bd = Infinity;
    for (var i = 0; i < list.length; i++) {
      var d = Math.abs(list[i][0] - w) + Math.abs(list[i][1] - h);
      if (d < bd) { bd = d; best = list[i]; }
    }
    return best;
  }
  function currentSizes() {
    var it = S.items[0];
    var set = it && it.set != null ? it.set : (it ? setOf(it.w, it.h) : 1);
    return sizesOf(set);
  }
  function setSize(item, w, h) {
    item.w = w; item.h = h;
    if (!S.sceneLocked && S.mode === 'scene') {
      var next = autoScene(w, h);
      if (next !== S.scene) { S.scene = next; ensureScene().then(function () { S.items.forEach(defaultPos); render(); }); }
    }
    defaultPos(item);
  }

  /* ----------------------------------------------------------------- UI */
  function syncSizes() {
    var box = $('[data-sow-sizes]'); if (!box) return;
    var list = currentSizes(), it = S.items[0];
    var p = plane(), maxW = p.wall ? p.wall.w / p.ppi : (S.photo && S.photo.wIn ? S.photo.wIn : 999);
    box.innerHTML = '';
    list.forEach(function (s) {
      var b = el('button', 'sow__opt'); b.type = 'button'; b.setAttribute('data-sow-size', s[0] + 'x' + s[1]);
      b.innerHTML = '<span>' + s[0] + '&times;' + s[1] + '</span>';
      if (it && it.w === s[0] && it.h === s[1]) b.className += ' is-on';
      if (s[0] > maxW - 4) { b.disabled = true; b.title = 'Wider than this wall'; }
      b.onclick = function () { setSize(S.items[0], s[0], s[1]); syncUI(); render(); writeHash(); track('tool_result', { size: s[0] + 'x' + s[1], handle: S.items[0].handle }); };
      box.appendChild(b);
    });
    var price = $('[data-sow-price]'), row = it && it.row;
    if (price) price.textContent = row && row[R.P] ? 'from ' + money(row[R.P]) : '';
  }
  function syncScenes() {
    var box = $('[data-sow-scenes]'); if (!box || box.childNodes.length) return;
    SCENES.forEach(function (sc) {
      var b = el('button', 'sow__scene'); b.type = 'button'; b.setAttribute('data-sow-scene', sc.id);
      var i = el('img'); i.src = sceneUrl(sc.n, true); i.alt = sc.label + ' wall'; i.loading = 'lazy';
      b.appendChild(i); b.appendChild(el('span', null, sc.label));
      b.onclick = function () {
        S.scene = sc.id; S.sceneLocked = true; S.mode = 'scene';
        ensureScene().then(function () { S.items.forEach(defaultPos); syncUI(); render(); writeHash(); });
        track('tool_result', { scene: sc.id });
      };
      box.appendChild(b);
    });
  }
  function syncUI() {
    $$('[data-sow-scene]').forEach(function (b) { b.classList.toggle('is-on', b.getAttribute('data-sow-scene') === S.scene && S.mode === 'scene'); });
    $$('[data-sow-frame]').forEach(function (b) { b.classList.toggle('is-on', b.getAttribute('data-sow-frame') === S.frame); });
    $$('[data-sow-tab]').forEach(function (b) { b.classList.toggle('is-on', b.getAttribute('data-sow-tab') === S.mode); });
    var ph = $('[data-sow-photo-panel]'); if (ph) ph.style.display = S.mode === 'photo' ? '' : 'none';
    var it = S.items[0];
    if (it) {
      var t = $('[data-sow-title]'), a = $('[data-sow-artist]'), th = $('[data-sow-thumb]'), cart = $('[data-sow-cart]');
      if (t) t.textContent = it.row ? it.row[R.T] : (it.local ? 'Your image' : 'Choose a painting');
      if (a) a.textContent = it.row ? it.row[R.A] : '';
      if (th && it.img) th.src = it.img.src;
      if (cart) {
        if (it.row) { cart.href = pdpUrl(it.row, it.w + 'x' + it.h); cart.style.display = ''; }
        else cart.style.display = 'none';
      }
    }
    syncSizes();
    var add = $('[data-sow-add]'); if (add) add.disabled = S.items.length >= 3;
    var u = $('[data-sow-unit]'); if (u) u.textContent = S.unit === 'cm' ? 'cm' : 'in';
  }

  /* ------------------------------------------------------------ picker */
  function renderResults(rows) {
    var box = $('[data-sow-results]'); box.innerHTML = '';
    if (!rows.length) { box.appendChild(el('p', 'sow__note', 'No match. Try an artist or a painting title.')); return; }
    rows.slice(0, 16).forEach(function (row) {
      var b = el('button'); b.type = 'button'; b.title = row[R.T] + ' by ' + row[R.A];
      var i = el('img'); i.src = imgUrl(row, 180); i.alt = row[R.T]; i.loading = 'lazy';
      b.appendChild(i);
      b.onclick = function () {
        var it = S.items[0];
        applyRow(it, row).then(function () {
          var list = sizesOf(it.set);
          var pick = list[2] || list[0];
          setSize(it, pick[0], pick[1]); syncUI(); render(); writeHash();
          track('tool_result', { handle: it.handle, size: it.w + 'x' + it.h });
        });
      };
      box.appendChild(b);
    });
  }
  function fitsFilter(rows) {
    var p = plane(); if (!p.wall || !p.ppi) return rows;
    var wall = p.wall.w / p.ppi;
    return rows.filter(function (row) {
      var list = sizesOf(row[R.Z] >= 0 ? +row[R.Z] : 1), best = 0;
      list.forEach(function (s) { if (s[0] <= wall - 12 && s[0] > best) best = s[0]; });
      return best >= wall * 0.6;
    });
  }

  /* ----------------------------------------------------------- wire-up */
  function wire() {
    syncScenes();
    $$('[data-sow-frame]').forEach(function (b) {
      b.onclick = function () { S.frame = b.getAttribute('data-sow-frame'); syncUI(); render(); writeHash(); };
    });
    $$('[data-sow-tab]').forEach(function (b) {
      b.onclick = function () {
        var m = b.getAttribute('data-sow-tab');
        if (m === 'photo' && (!S.photo || !S.photo.img)) { $('[data-sow-file]').click(); return; }
        S.mode = m; if (m === 'scene') { ensureScene().then(function () { S.items.forEach(defaultPos); syncUI(); render(); }); }
        else { S.items.forEach(defaultPos); }
        syncUI(); render(); writeHash();
      };
    });
    $('[data-sow-file]').onchange = function (e) { if (e.target.files && e.target.files[0]) usePhoto(e.target.files[0]); };
    var artFile = $('[data-sow-artfile]');
    if (artFile) artFile.onchange = function (e) {
      var f = e.target.files && e.target.files[0]; if (!f) return;
      var fr = new FileReader();
      fr.onload = function () {
        loadImage(fr.result, false).then(function (img) {
          var it = S.items[0]; it.img = img; it.row = null; it.handle = ''; it.local = 1;
          it.set = img.naturalWidth === img.naturalHeight ? 2 : img.naturalWidth > img.naturalHeight ? 1 : 0;
          var list = sizesOf(it.set); setSize(it, list[2][0], list[2][1]);
          syncUI(); render(); writeHash();
        });
      };
      fr.readAsDataURL(f);
    };
    var q = $('[data-sow-q]'), fits = $('[data-sow-fits]');
    var go = function () {
      var v = q.value.trim();
      if (v.length < 2) { renderResults([]); return; }
      search(v, { limit: 40 }).then(function (rows) {
        if (!rows.length) { $('[data-sow-results]').innerHTML = ''; $('[data-sow-results]').appendChild(el('p', 'sow__note', 'The catalogue index is still loading. Try again in a moment.')); return; }
        renderResults(fits && fits.checked ? fitsFilter(rows) : rows);
      });
    };
    var t = null;
    q.oninput = function () { clearTimeout(t); t = setTimeout(go, 260); };
    if (fits) fits.onchange = go;
    $('[data-sow-dims]').onchange = function (e) { S.dims = e.target.checked; render(); writeHash(); };
    $('[data-sow-compare]').onchange = function (e) { S.compare = e.target.checked; render(); writeHash(); };
    $('[data-sow-units]').onclick = function () { S.unit = S.unit === 'in' ? 'cm' : 'in'; syncUI(); render(); writeHash(); };
    $('[data-sow-add]').onclick = function () {
      if (S.items.length >= 3) return;
      var base = S.items[0], it = blankItem();
      it.row = base.row; it.handle = base.handle; it.img = base.img; it.set = base.set; it.w = base.w; it.h = base.h;
      defaultPos(it);
      it.y = base.y;
      it.x = clampX(base.x + (base.w + 3) * plane().ppi * 100 / plane().w, base.w);
      S.items.push(it); syncUI(); render(); writeHash();
    };
    $$('[data-sow-gallery]').forEach(function (b) {
      b.onclick = function () {
        var n = +b.getAttribute('data-sow-gallery'), base = S.items[0], p = plane();
        S.items = [base];
        for (var i = 1; i < n; i++) {
          var it = blankItem();
          it.row = base.row; it.handle = base.handle; it.img = base.img; it.set = base.set; it.w = base.w; it.h = base.h;
          it.y = base.y; S.items.push(it);
        }
        /* the whole group is centred as one rectangle, inside the usable wall */
        var stepPct = (base.w + 3) * p.ppi / p.w * 100;
        var half = stepPct * (n - 1) / 2;
        var edge = base.w * p.ppi / p.w * 100 / 2;
        var lo = (p.wall ? p.wall.x : 0) / p.w * 100 + edge + half;
        var hi = (p.wall ? p.wall.x + p.wall.w : p.w) / p.w * 100 - edge - half;
        var mid = lo > hi ? 50 : clamp(p.scene ? p.scene.cx : 50, lo, hi);
        var start = mid - half;
        S.items.forEach(function (it, i) { it.x = clamp(start + stepPct * i, 2, 98); });
        syncUI(); render(); writeHash();
        track('tool_result', { gallery: n });
      };
    });
    $('[data-sow-reset]').onclick = function () { S.items = S.items.slice(0, 1); S.items.forEach(defaultPos); syncUI(); render(); writeHash(); };
    $('[data-sow-download]').onclick = function () {
      try {
        var url = exportJpeg();
        var a = document.createElement('a');
        a.href = url; a.download = 'art-and-see-wall.jpg'; document.body.appendChild(a); a.click(); a.remove();
        track('tool_cta_click', { cta: 'download', handle: S.items[0].handle });
      } catch (err) { setHint('This image could not be exported: ' + err.name); }
    };
    $('[data-sow-copy]').onclick = function (e) {
      var url = location.href;
      var done = function () { e.target.textContent = 'Link copied'; setTimeout(function () { e.target.textContent = 'Copy link'; }, 1800); };
      if (navigator.clipboard) navigator.clipboard.writeText(url).then(done, done); else done();
      track('tool_cta_click', { cta: 'copy_link' });
    };
    var cart = $('[data-sow-cart]');
    if (cart) cart.onclick = function () { track('tool_cta_click', { cta: 'add_to_cart', handle: S.items[0].handle, size: S.items[0].w + 'x' + S.items[0].h }); };
    var sel = $('[data-sow-preset]');
    if (sel) sel.onchange = function () {
      S.preset = sel.value;
      var r = REFS.filter(function (x) { return x.id === S.preset; })[0];
      S.refInches = r.inches;
      $('[data-sow-refin]').style.display = S.preset === 'wall' ? '' : 'none';
      if (S.photo) { calib.active = true; setHint('Drag a line across your reference.'); render(); }
    };
    var recal = $('[data-sow-recal]');
    if (recal) recal.onclick = function () { if (S.photo) { calib.active = true; calib.a = calib.b = null; setHint('Drag a line across your reference.'); render(); } };
    var fl = $('[data-sow-floor]');
    if (fl) fl.onclick = function () {
      if (!S.photo) return;
      calib.floorMode = true; setHint('Click where the wall meets the floor.');
      var once = function (e) {
        var q2 = pos(e); S.photo.floor = q2.y / view.k; calib.floorMode = false;
        canvas.removeEventListener('click', once); setHint('Floor line set. The 57 in centre guide is on.');
        S.items.forEach(defaultPos); saveWall(); render(); writeHash();
      };
      canvas.addEventListener('click', once);
    };
    var open = $('[data-sow-open]'), close = $('[data-sow-close]');
    if (open) open.onclick = function () { document.body.classList.add('sow-open'); S.open = true; setTimeout(render, 30); track('tool_cta_click', { cta: 'open_mobile' }); };
    if (close) close.onclick = function () { document.body.classList.remove('sow-open'); S.open = false; setTimeout(render, 30); };
    var rt = null;
    window.addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(render, 150); });
    window.addEventListener('hashchange', function () { if (!hashTimer) boot(true); });
  }

  /* -------------------------------------------------------------- boot */
  function fallbackRow() {
    var d = CFG.def;
    if (!d) return null;
    var row = []; row[R.H] = d.handle; row[R.T] = d.title; row[R.A] = d.artist; row[R.RAT] = d.ratio;
    row[R.P] = d.price; row[R.E] = d.orient; row[R.Z] = d.set; row[R.IMG] = d.img;
    row.__url = d.url;
    return row;
  }
  function rowImageUrl(row) { return row.__url || imgUrl(row, 700); }

  function findRow(handle, sizeHint) {
    var which = !sizeHint ? 'all' : (sizeHint.w > sizeHint.h ? 'h' : sizeHint.w < sizeHint.h ? 'v' : 's');
    return load(which).then(function (rows) {
      for (var i = 0; i < rows.length; i++) if (rows[i][R.H] === handle) return rows[i];
      return null;
    });
  }

  function boot(fromHash) {
    var h = readHash();
    S.frame = FRAMES.indexOf(h.frame) >= 0 ? h.frame : 'none';
    S.unit = h.u === 'cm' ? 'cm' : 'in';
    S.dims = h.d === '1'; S.compare = h.c === '1';
    if (h.scene && sceneById(h.scene)) { S.scene = h.scene; S.sceneLocked = true; }
    var size = parseSize(h.size);
    var it = blankItem();
    if (size) { it.w = size.w; it.h = size.h; it.set = setOf(size.w, size.h); }
    S.items = [it];
    for (var n = 2; n <= 3; n++) {
      if (!h['size' + n] && !h['art' + n]) continue;
      var j = blankItem(), s2 = parseSize(h['size' + n]);
      if (s2) { j.w = s2.w; j.h = s2.h; j.set = setOf(s2.w, s2.h); }
      j.handle = h['art' + n] || '';
      j.x = num(h['x' + n], 50); j.y = num(h['y' + n], 45);
      S.items.push(j);
    }
    var chk = $('[data-sow-dims]'); if (chk) chk.checked = S.dims;
    var chk2 = $('[data-sow-compare]'); if (chk2) chk2.checked = S.compare;

    var handle = h.art || (CFG.def && CFG.def.handle) || '';
    var started = handle ? findRow(handle, size) : search('starry night', { limit: 8, orientation: 'h' }).then(function (rows) { return rows[0] || null; });

    started.then(function (row) {
      if (!row) row = fallbackRow();
      if (!row) return;
      var ready;
      if (row.__url) {
        it.row = row; it.handle = row[R.H]; it.set = row[R.Z];
        ready = loadImage(rowImageUrl(row)).then(function (i) { it.img = i; }).catch(function () { });
      } else ready = applyRow(it, row);
      return ready.then(function () {
        var set0 = it.set != null ? it.set : 1;
        if (!size) { var pick = sizesOf(set0)[2]; it.w = pick[0]; it.h = pick[1]; }
        else { var sn = snapSize(set0, size.w, size.h); it.w = sn[0]; it.h = sn[1]; }
        if (!S.sceneLocked) S.scene = autoScene(it.w, it.h);
        /* the extra pieces reuse the same artwork unless their own handle resolves */
        for (var k = 1; k < S.items.length; k++) {
          var o = S.items[k];
          o.row = it.row; o.img = it.img; o.set = it.set;
          var so = snapSize(set0, o.w, o.h); o.w = so[0]; o.h = so[1];
        }
        return ensureScene();
      }).then(function () {
        S.items.forEach(function (item, i) {
          if (i === 0 && h.x != null && h.y != null) { item.x = num(h.x, item.x); item.y = num(h.y, item.y); }
          else if (i === 0) defaultPos(item);
          else if (h['x' + (i + 1)] == null) defaultPos(item);
        });
        syncUI(); render(); if (!fromHash) writeHash();
        track('tool_open', { handle: it.handle, size: it.w + 'x' + it.h, scene: S.scene });
      });
    }).catch(function (e) { setHint('The catalogue could not be loaded. The scenes and sizes still work.'); ensureScene().then(function () { syncUI(); render(); }); });

    ensureScene().then(function () { syncUI(); render(); });
  }

  wire();
  renderWalls();
  boot(false);
  window.SOWDebug = { state: S, scenes: SCENES, render: render, plane: plane, boxes: function () { return lastBoxes; }, exportJpeg: exportJpeg };
})();
